import { Component, Input, OnInit } from '@angular/core';
import { DetailEvent } from 'src/app/Models/MiAuto/DetailEvent';
import { GroupEvent } from 'src/app/Models/MiAuto/GroupEvent';

@Component({
  selector: 'app-menu-auto',
  templateUrl: './menu-auto.component.html',
  styleUrls: ['./menu-auto.component.css']
})
export class MenuAutoComponent implements OnInit {

  @Input()
  listGroupEvent: GroupEvent[];
  noDataTabla: boolean;
  selectedEvents: Array<DetailEvent>;

  constructor() {
    this.noDataTabla = false;

   }

  ngOnInit() {
  }

  next(Eventos: Array<DetailEvent>): void { 
    this.noDataTabla = true;
    this.selectedEvents = Eventos;
  }

  clearTable(): void { 
    this.noDataTabla = false;
  }
}
